module.exports = __webpack_public_path__ + "img/default-sensor-off.be7da509.svg";